import { createImgTileMapType, plainPlacement } from './imgTileMapType';

const MERC = 20037508.342789244;

function normaliseCoord(coord, zoom) {
  const n = 2 ** zoom;
  if (coord.y < 0 || coord.y >= n) return null;
  return {
    x: ((coord.x % n) + n) % n,
    y: coord.y,
  };
}

export function bbox3857(x, y, z) {
  const n = 2 ** z;
  const size = (2 * MERC) / n;
  const minX = -MERC + x * size;
  const maxX = -MERC + (x + 1) * size;
  const maxY = MERC - y * size;
  const minY = MERC - (y + 1) * size;
  return `${minX},${minY},${maxX},${maxY}`;
}

export function bboxCrs84(x, y, z) {
  const n = 2 ** z;
  const lon = (xx) => (xx / n) * 360 - 180;
  const lat = (yy) =>
    (Math.atan(Math.sinh(Math.PI * (1 - (2 * yy) / n))) * 180) / Math.PI;
  return `${lon(x)},${lat(y + 1)},${lon(x + 1)},${lat(y)}`;
}

export function buildWmsTileUrl(source, coord, zoom) {
  // Guard against transient bad calls (seen on mobile during rapid zoom): a null
  // coord or non-finite zoom would otherwise emit a poisoned BBOX=NaN URL. Returning
  // null is Google's documented "no tile here" contract and won't wedge the layer.
  if (!coord || typeof zoom !== 'number' || !Number.isFinite(zoom)) return null;

  const wrapped = normaliseCoord(coord, zoom);
  if (!wrapped) return null;

  const params = new URLSearchParams({
    SERVICE: 'WMS',
    REQUEST: 'GetMap',
    LAYERS: source.layerName,
    STYLES: '',
    FORMAT: 'image/png',
    TRANSPARENT: 'true',
    WIDTH: '256',
    HEIGHT: '256',
  });

  if (source.tileSrs === 'CRS:84') {
    params.set('VERSION', '1.3.0');
    params.set('CRS', 'CRS:84');
    params.set('BBOX', bboxCrs84(wrapped.x, wrapped.y, zoom));
  } else {
    params.set('VERSION', '1.1.1');
    params.set('SRS', 'EPSG:3857');
    params.set('BBOX', bbox3857(wrapped.x, wrapped.y, zoom));
  }

  return `${source.wmsBase}?${params.toString()}`;
}

export function createWmsImageMapType(source, opacity, onOutcome) {
  // Plain-object MapType rather than ImageMapType: see lib/adapters/imgTileMapType.js.
  // ImageMapType cannot report a failed tile, and without that a dead WMS looks
  // exactly like a live one to the layer panel.
  return createImgTileMapType({
    id: source.id,
    opacity,
    onOutcome,
    resolve: (coord, zoom) => plainPlacement(buildWmsTileUrl(source, coord, zoom)),
  });
}
